import cn from 'classnames';
import { useEffect, useState } from 'react';

import { ChipsFilter, ChipsFilterProps } from './ChipsFilter';
import { Variant } from './ChipsFilter/constants';
import s from './ChipsFilterRow.module.scss';

export type ChipProps = Pick<ChipsFilterProps, 'id' | 'label' | 'isDisabled'>;

export interface ChipsFilterRowProps {
  chips: ChipProps[];
  defaultActive: string;
  className?: string;
  variant?: Variant;
  onClick: (id: string) => void;
}

export function ChipsFilterRow({
  chips,
  defaultActive,
  onClick,
  className = '',
  variant,
}: ChipsFilterRowProps) {
  const [active, setActive] = useState<string>();

  const handleClick = (id: string) => {
    setActive(id);
    onClick(id);
  };

  useEffect(() => {
    setActive(defaultActive);
  }, [defaultActive]);

  return (
    <div className={cn(s.root, className)}>
      {chips.map((chip) => (
        <ChipsFilter
          key={chip.id}
          id={chip.id}
          label={chip.label}
          isDisabled={chip.isDisabled}
          onClick={handleClick}
          variant={variant}
          isActive={active === chip.id}
        />
      ))}
    </div>
  );
}
